const minValue = 8
const maxValue = 14

export { minValue, maxValue }